import { render, staticRenderFns } from "./examFinish.vue?vue&type=template&id=70a3025e&scoped=true&"
import script from "./examFinish.vue?vue&type=script&lang=js&"
export * from "./examFinish.vue?vue&type=script&lang=js&"
import style0 from "./examFinish.vue?vue&type=style&index=0&id=70a3025e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a3025e",
  null
  
)

export default component.exports